var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAttributesDark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 38,
    viewBox: "0 0 50 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.732 16.5C25.9622 17.8333 24.0377 17.8333 23.2679 16.5L15.4737 3C14.7039 1.66667 15.6662 1.95249e-06 17.2058 0H32.7942C34.3338 0 35.2961 1.66667 34.5263 3L26.732 16.5ZM31.0622 3L25 13.5L18.9378 3L31.0622 3Z",
    fill: "#071A24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 22C0 20.8954 0.895431 20 2 20H16C17.1046 20 18 20.8954 18 22V36C18 37.1046 17.1046 38 16 38H2C0.89543 38 0 37.1046 0 36V22ZM3 35V23H15V35H3Z",
    fill: "#071A24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 38C45.9706 38 50 33.9706 50 29C50 24.0294 45.9706 20 41 20C36.0294 20 32 24.0294 32 29C32 33.9706 36.0294 38 41 38ZM41 35C44.3137 35 47 32.3137 47 29C47 25.6863 44.3137 23 41 23C37.6863 23 35 25.6863 35 29C35 32.3137 37.6863 35 41 35Z",
    fill: "#071A24"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.727 18.2351C38.0274 14.7423 36.0281 11.7192 33.2549 9.69141L34.7615 7.08008C38.3671 9.61324 40.9438 13.5118 41.7405 18.0245C41.4958 18.0082 41.2488 17.9999 41 17.9999C40.2208 17.9999 39.4605 18.081 38.727 18.2351Z",
    fill: "#071A24"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.26385 18C9.06548 13.4977 11.6394 9.60866 15.2385 7.08008L16.7451 9.69141C14.0343 11.6736 12.063 14.6068 11.3222 18H8.26385Z",
    fill: "#071A24"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0242 33.6412C29.1995 34.5123 27.1567 34.9999 25 34.9999C23.2384 34.9999 21.5528 34.6746 20 34.0807V37.2527C21.5808 37.7385 23.2599 37.9999 25 37.9999C27.7575 37.9999 30.3616 37.3434 32.6647 36.1781C32.008 35.4163 31.454 34.5635 31.0242 33.6412Z",
    fill: "#071A24"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAttributesDark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/attributes_dark.5d328fbc2b9b5f511296b2bb9d012539.svg";